// extracted by mini-css-extract-plugin
export default {"containerForm":"ConfirmTokenPage_containerForm__PZ8-G"};